import React from 'react';
import { IoChevronBack, IoClose } from 'react-icons/io5';
import combineStyles from '../utils/combineStyles';
import getThemeLookup from '../selectors/getThemeLookup';
import ModalFloatingButton from './ModalFloatingButton';
import Text from './Text';
import { useAppSelector } from '../app/hooks';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import { CONTAINER_PROPERTIES } from '../utils/theme';

interface IProps {
  title?: string;
  onClose?: () => void;
  onGoBack?: () => void;
  locked?: boolean;
  backButtonEnabled?: boolean;
  closeButtonEnabled?: boolean;
  containerStyle?: React.CSSProperties;
  closeButtonLeft?: boolean;
}

const ModalFloatingHeader: React.FC<IProps> = ({
  title,
  onClose,
  onGoBack,
  locked,
  backButtonEnabled,
  closeButtonEnabled = true,
  containerStyle,
  closeButtonLeft,
}) => {
  const p = useAppSelector(getThemeLookup);
  const isMobileDevice = useAppSelector(getDeviceTypeMobile);

  const backButton = (
    <ModalFloatingButton
      onClick={onGoBack!}
      IconComponent={IoChevronBack}
      buttonStyle={{ padding: 4 }}
      disabled={locked}
      containerStyle={
        isMobileDevice
          ? combineStyles(
              {
                scale: '1.2',
                translate: '0.75em 0.75em',
              },
              p('modalMobileBackButton', CONTAINER_PROPERTIES),
            )
          : {}
      }
    />
  );

  // Added back heath's code
  const modalTitle = <Text themeKey="modalTitle">{title}af;opsdj</Text>;

  const closeButton = (
    <ModalFloatingButton
      onClick={onClose!}
      IconComponent={IoClose}
      disabled={locked}
      containerStyle={
        isMobileDevice
          ? combineStyles(
              {
                translate: '-0.5em 0.75em',
              },
              p('modalMobileCloseButton', CONTAINER_PROPERTIES),
            )
          : {}
      }
    />
  );

  const renderDesktopButton = () => {
    if (backButtonEnabled) {
      return backButton;
    }

    if (closeButtonEnabled) {
      return closeButton;
    }

    return null;
  };

  return (
    <div style={{ position: 'absolute', width: '100%', pointerEvents: 'none', top: 0 }}>
      <div
        style={combineStyles(
          {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: closeButtonLeft ? 'flex-end' : 'flex-start',
            alignItems: 'flex-start',
            padding: isMobileDevice ? 5 : 20,
            width: '100%',
          },
          containerStyle,
        )}
      >
        {isMobileDevice ? (
          <>
            <div style={{ flexShrink: 1 }}>{backButtonEnabled && backButton}</div>

            <div style={{ flexShrink: 1 }}>
              {!backButtonEnabled && closeButtonEnabled && closeButton}
            </div>
          </>
        ) : (
          <>
            <div style={{ flexShrink: 1 }}>{renderDesktopButton()}</div>
            <div
              style={{
                position: 'absolute',
                display: 'flex',
                width: '100%',
                left: 0,
                boxSizing: 'content-box',
                flexDirection: 'row',
                justifyContent: 'center',
              }}
            >
              {' '}
              {!!title && modalTitle}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalFloatingHeader;
